import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trademark-obligation',
  templateUrl: './trademark-obligation.component.html',
  styleUrls: ['./trademark-obligation.component.scss']
})
export class TrademarkObligationComponent {
  @Input() obligated: boolean = false;
}
